module.exports = __webpack_public_path__ + "img/pariwisata.a5a52407.jpg";